import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  FormControlLabel,
  Checkbox,
  Avatar,
} from '@material-ui/core';
import styles from './styles';
import {
  disableInventoryContainer,
  enableInventoryContainer,
  SaveApiResMessage,
} from '@/actions';
import { useNotify } from 'react-admin';
import closeIcon from '../../assets/img/closeIcon.svg';
import onwChassisICon from '../../assets/img/own_chases.jpeg';

export default ({
  DATA = [],
  open,
  selectedRow,
  setShowContainersModal,
  getInventoryList,
}) => {
  const cls = styles();
  const notify = useNotify();
  const [containers, setContainers] = useState(selectedRow.containers);
  const [refreshInventories, setRefreshInventories] = useState(false);

  const updateContainers = (index, name, value) => {
    setContainers((prev) => {
      return [
        ...prev.slice(0, index),
        {
          ...prev[index],
          [name]: value,
        },
        ...prev.slice(index + 1),
      ];
    });
  };

  const handleEnableCongtainer = (containerId, index) => {
    enableInventoryContainer(containerId).then((response) => {
      if (response.success) {
        // notify('container updated');
        SaveApiResMessage({
          title: response?.data?.messageHeader,
          message: 'container updated',
          mode: 'success',
        });
        updateContainers(index, 'status', 1);
        setRefreshInventories(true);
      } else {
        // notify('somthing went wrong!');
        SaveApiResMessage({
          title: 'Error',
          message: 'somthing went wrong!',
          mode: 'error',
        });
      }
    });
  };

  const handleDisableContainer = (containerId, index) => {
    disableInventoryContainer(containerId).then((response) => {
      if (response.success) {
        // notify('container updated');
        SaveApiResMessage({
          title: response?.data?.messageHeader,
          message: 'container updated',
          mode: 'success',
        });
        updateContainers(index, 'status', 0);
        setRefreshInventories(true);
      } else {
        // notify('somthing went wrong!');
        SaveApiResMessage({
          title: 'Error',
          message: 'somthing went wrong!',
          mode: 'error',
        });
      }
    });
  };

  const handleChangeContainerStatus = (value, containerId, index) => {
    if (value === true) {
      handleEnableCongtainer(containerId, index);
    } else {
      handleDisableContainer(containerId, index);
    }
  };

  const getInventoryContainers = () => {
    let inventoryContainers = [];
    for (let index = 0; index < selectedRow.containers.length; index++) {
      console.log(
        'selectedRow.containers[index].status',
        selectedRow.containers[index].status
      );

      if (
        selectedRow.containers[index].status === 1 ||
        selectedRow.containers[index].status === 0
      ) {
        inventoryContainers.push({
          name: selectedRow.containers[index]
            ? selectedRow.containers[index].name
            : '',
          chases: selectedRow.containers[index]
            ? selectedRow.containers[index].chases
            : '',
          id: selectedRow.containers[index]
            ? selectedRow.containers[index].id
            : null,
          status: selectedRow.containers[index]
            ? selectedRow.containers[index].status
            : null,
          own_chases: selectedRow.containers[index]
            ? selectedRow.containers[index].own_chases
            : null,
        });
      }
    }
    setContainers(inventoryContainers);
  };

  useEffect(() => {
    getInventoryContainers();
  }, []);

  const gatEditContainersContent = () => {
    return (
      <table className={cls.containerTable}>
        <thead>
          <tr>
            <th style={{ flex: '0.3' }}>#</th>
            <th style={{ flex: '1' }}>Container#</th>
            <th style={{ flex: '1' }}>Chassis#</th>
            <th style={{ flex: '0.5' }}>Type</th>
            <th style={{ flex: '0.3' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {containers.map((container, index) => {
            return (
              <tr key={index}>
                <td style={{ flex: '0.3' }}>{index + 1}</td>
                <td style={{ flex: '1' }}>
                  <span>
                    {container.name ? container.name : 'Not Applicable'}
                  </span>
                </td>
                <td style={{ flex: '1' }}>
                  <div className={cls.chassisNameContainer}>
                    <span>
                      {container.chases ? container.chases : 'Not Applicable'}
                    </span>
                    {/* {container.own_chases === 1 && (
                      <Avatar src={onwChassisICon} />
                    )} */}
                  </div>
                </td>{' '}
                <td style={{ flex: '0.5' }}>
                  <div className={cls.chassisNameContainer}>
                    {container.own_chases === 1 ? 'Own' : 'Pool'}
                  </div>
                </td>
                <td style={{ flex: '0.3' }}>
                  {container.status !== null && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={container.status === 1 ? true : false}
                          className={cls.checkbox}
                          onChange={(e) =>
                            handleChangeContainerStatus(
                              e.target.checked,
                              container.id,
                              index
                            )
                          }
                        />
                      }
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <div>
      <Modal open={open}>
        <div
          id="app_modal"
          className={cls.modal}
          onClick={(e) => {
            if (e.target.id === 'app_modal') {
              setShowContainersModal(false);
              refreshInventories && getInventoryList();
              setRefreshInventories(false);
            }
          }}
          style={{ width: '100%', height: '100%' }}>
          <Box className={cls.modalBox}>
            <div
              onClick={() => {
                setShowContainersModal(false);
                refreshInventories && getInventoryList();
                setRefreshInventories(false);
              }}
              className={cls.closeModal}>
              <img alt="close_icon" src={closeIcon} />
            </div>
            <h3 className={cls.modalTitle}>Container Availability</h3>
            <div className={cls.containersTableContainer}>
              {gatEditContainersContent()}
            </div>
            <span className={cls.updateContainersBtnSpan}>
              {/* <button
                className={cls.updateContainersBtnClose}
                onClick={() => {
                  setShowContainersModal(false);
                }}>
                Close
              </button> */}
              <button
                className={cls.updateContainersBtnSave}
                onClick={() => {
                  setShowContainersModal(false);
                  refreshInventories && getInventoryList();
                  setRefreshInventories(false);
                }}>
                Close
              </button>
            </span>
          </Box>
        </div>
      </Modal>
    </div>
  );
};
